module.exports = __webpack_public_path__ + "d6d8b1a4.svg";